import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import BillingService from 'cio/services/billing';
import AuthenticatedAccountCanceledController from 'cio/pods/authenticated/account-canceled/controller';

export default class AccountCanceledRoute extends Route {
  @service analytics!: AnalyticsService;
  @service billing!: BillingService;

  async beforeModel() {
    try {
      await this.billing.initialize({ refresh: true, paramPlanSlug: '', code: '', ignoreErrors: true });
    } catch {
      // If the endpoint to return billing info returns an error, we don't
      // care. This page will remain the same, we will just not allow users to
      // reactivate.
    }
  }

  activate() {
    let controller = this.controllerFor(this.routeName) as AuthenticatedAccountCanceledController;

    this.analytics.track('account', 'canceled_state_viewed', {
      canReactivate: controller.canReactivate,
    });
  }
}
